var map = {
	"./abomination.json": 399,
	"./abominationimmortal.json": 400,
	"./aegon.json": 401,
	"./agentvenom.json": 402,
	"./airwalker.json": 403,
	"./americachavez.json": 404,
	"./angela.json": 405,
	"./annihilus.json": 406,
	"./apocalypse.json": 407,
	"./archangel.json": 408,
	"./beast.json": 409,
	"./bishop.json": 410,
	"./blackbolt.json": 411,
	"./blackpanther.json": 412,
	"./blackpanthercivilwar.json": 413,
	"./blackwidowclaire.json": 414,
	"./blackwidowdeadly.json": 415,
	"./blade.json": 416,
	"./brothervoodoo.json": 417,
	"./cable.json": 418,
	"./capamericaiw.json": 419,
	"./captainamerica.json": 420,
	"./captainamericawwii.json": 421,
	"./captainmarvel.json": 422,
	"./captainmarvelmovie.json": 423,
	"./carnage.json": 424,
	"./civilwarrior.json": 425,
	"./collector.json": 426,
	"./corvusglaive.json": 427,
	"./cosmicghostrider.json": 428,
	"./crossbones.json": 429,
	"./cullobsidian.json": 430,
	"./cyclops90s.json": 431,
	"./daredevilnetflix.json": 432,
	"./darkhawk.json": 433,
	"./darkphoenix.json": 434,
	"./deadpoolxforce.json": 435,
	"./diablo.json": 436,
	"./docock.json": 437,
	"./domino.json": 438,
	"./dormammu.json": 439,
	"./dragonman.json": 440,
	"./drdoom.json": 441,
	"./drstrange.json": 442,
	"./ebonymaw.json": 443,
	"./elektra.json": 444,
	"./emmafrost.json": 445,
	"./falcon.json": 446,
	"./gambit.json": 447,
	"./gamora.json": 448,
	"./ghost.json": 449,
	"./ghostrider.json": 450,
	"./grandmaster.json": 451,
	"./greengoblin.json": 452,
	"./groot.json": 453,
	"./grootking.json": 454,
	"./guardian.json": 455,
	"./guillotine.json": 456,
	"./guillotine2099.json": 457,
	"./gwenpool.json": 458,
	"./havok.json": 459,
	"./heimdall.json": 460,
	"./hela.json": 461,
	"./hercules.json": 462,
	"./hitmonkey.json": 463,
	"./hood.json": 464,
	"./howardtheduck.json": 465,
	"./hulk.json": 466,
	"./hulkimmortal.json": 467,
	"./hulkragnarok.json": 468,
	"./humantorch.json": 469,
	"./hyperion.json": 470,
	"./iceman.json": 471,
	"./invisiblewoman.json": 472,
	"./ironfist.json": 473,
	"./ironfistwhite.json": 474,
	"./ironman.json": 475,
	"./ironmaniw.json": 476,
	"./jabaripanther.json": 477,
	"./joefixit.json": 478,
	"./jubilee.json": 479,
	"./juggernaut.json": 480,
	"./kamalakhan.json": 481,
	"./kang.json": 482,
	"./karlmordo.json": 483,
	"./karnak.json": 484,
	"./killmonger.json": 485,
	"./kingpin.json": 486,
	"./kittypryde.json": 487,
	"./korg.json": 488,
	"./loki.json": 489,
	"./longshot.json": 490,
	"./lukecage.json": 491,
	"./maestro.json": 492,
	"./magik.json": 493,
	"./magneto.json": 494,
	"./magnetomarvelnow.json": 495,
	"./mangog.json": 496,
	"./manthing.json": 497,
	"./masacre.json": 498,
	"./medusa.json": 499,
	"./mephisto.json": 500,
	"./misternegative.json": 501,
	"./mistersinister.json": 502,
	"./modok.json": 503,
	"./mojo.json": 504,
	"./moleman.json": 505,
	"./moonknight.json": 506,
	"./morningstar.json": 507,
	"./mrfantastic.json": 508,
	"./namor.json": 509,
	"./nebula.json": 510,
	"./nickfury.json": 511,
	"./nightcrawler.json": 512,
	"./nightthrasher.json": 513,
	"./nimrod.json": 514,
	"./nova.json": 515,
	"./odin.json": 516,
	"./omegared.json": 517,
	"./peniparker.json": 518,
	"./phoenix.json": 519,
	"./platinumpool.json": 520,
	"./professorx.json": 521,
	"./proximamidnight.json": 522,
	"./psychoman.json": 523,
	"./psylockexforce.json": 524,
	"./punisher2099.json": 525,
	"./purgatory.json": 526,
	"./quake.json": 527,
	"./redgoblin.json": 528,
	"./redguardian.json": 529,
	"./redhulk.json": 530,
	"./redskull.json": 531,
	"./rogue.json": 532,
	"./ronin.json": 533,
	"./sabretooth.json": 534,
	"./sasquatch.json": 535,
	"./scarletwitch.json": 536,
	"./scarletwitchsigil.json": 537,
	"./sentinel.json": 538,
	"./sentry.json": 539,
	"./shangchi.json": 540,
	"./shehulk.json": 541,
	"./silvercenturion.json": 542,
	"./silversurfer.json": 543,
	"./sorcerersupreme.json": 544,
	"./spidergwen.json": 545,
	"./spiderham.json": 546,
	"./spiderman2099.json": 547,
	"./spidermanblack.json": 548,
	"./spidermanmorales.json": 549,
	"./spidermanmovie.json": 550,
	"./squirrelgirl.json": 551,
	"./stormpyramidx.json": 552,
	"./stryfe.json": 553,
	"./sunspot.json": 554,
	"./superskrull.json": 555,
	"./taskmaster.json": 556,
	"./template.json": 557,
	"./terrax.json": 558,
	"./thechampion.json": 559,
	"./theoverseer.json": 560,
	"./thevision.json": 561,
	"./thing.json": 562,
	"./thorjanefoster.json": 563,
	"./thorragnarok.json": 564,
	"./tigra.json": 565,
	"./ultron.json": 566,
	"./ultronclassic.json": 567,
	"./unstoppablecolossus.json": 568,
	"./venom.json": 569,
	"./venompool.json": 570,
	"./vision.json": 571,
	"./visionaarkus.json": 572,
	"./void.json": 573,
	"./vulture.json": 574,
	"./warlock.json": 575,
	"./warmachine.json": 576,
	"./wasp.json": 577,
	"./weaponx.json": 578,
	"./wolverineoldman.json": 579,
	"./x23.json": 580,
	"./yellowjacket.json": 581,
	"./yondu.json": 582
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 398;



//////////////////
// WEBPACK FOOTER
// ./src/data/guides \.json$
// module id = 398
// module chunks = 0